<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
      <b-card>
          <div slot="header">
            <strong>Search WTR</strong>
          </div>
          <b-row>
              <b-col sm="2">
                  <b-form-group>
                      <label for="wto_num">WTO No</label>
                          <b-form-input type="text" id="wto_num" v-model="filter.wto_num"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                  <b-form-group>
                      <label for="gro_num">WTR No</label>
                          <b-form-input type="text" id="wtr_num" v-model="filter.wtr_num"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                  <b-form-group>
                      <label for="country_id">Country</label>
                      <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                    <label for="date_start">Date Start</label>
                        <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                </b-form-group>
              </b-col>
            <b-col sm="2">
                <b-form-group>
                    <label for="date_end">Date End</label>
                        <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                    <label for="status">Status</label>
                        <b-form-select id="status" v-model="filter.status"
                              :plain="true"
                              :options="['','OPEN', 'CLOSE', 'MANUAL-CLOSED']"
                              value="">
                        </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer">
              <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
              &nbsp;&nbsp;
              <b-button type="submit" size="lg" variant="success" v-if="isWtrAdmin" @click="newWTR">New WTR</b-button>
          </div>
      </b-card>
      <b-row v-if="getRowCount(searchResults) > 0 && !loading">
          <b-col sm="12" >
            <b-card>
                <div slot="header">
                    <strong>Search Results</strong>
                </div>
                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage"
                :per-page="perPage" :items="searchResults" @row-clicked="rowClick">
                </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
              <div slot="footer">
                  <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data   = "searchResults" :fields = "exportHeaders" name = "wtr.xls">
                      Export to Excel
                  </exportExcel>
                  &nbsp;
                  <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else-if="noResults && !loading">
              <b-col sm="12">
                <div align="center">
                  <strong>No WTR Found</strong>
                </div>
              </b-col>
          </b-row>
    </div>
  </template>
  <script>
  import axios from 'axios'
  import spinner from '@/components/Spinner.vue'
  import countryLookup from '@/components/Autocomplete.vue'
  import {authHeader, apiCountryLookup} from '@/functions/common.vue'
  import {apiWtrSearch} from '@/functions/common.vue'
  import exportExcel from 'vue-json-excel'

  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };
  export default
    {
      components:{spinner,countryLookup,exportExcel},
      props: {
        caption:
        {
          type: String,
          default: 'Table'
        },
        hover:
        {
          type: Boolean,
          default: false
        },
        striped:
        {
          type: Boolean,
          default: false
        },
        bordered:
        {
          type: Boolean,
          default: false
        },
        small:
        {
          type: Boolean,
          default: false
        },
        fixed:
        {
          type: Boolean,
          default: false
        }
      },
      data: () => {
        return {
          isWtrAdmin: false,
          apiCountryLookup:apiCountryLookup,
          loading: false,
          noResults: false,
          filter:
            {
              wto_num: '',
              wtr_num:'',
              country_id: '',
              date_start: '',
              date_end: '',
              status:''
            },
          searchResults: [],
          searchResultsFields:
          [
          {key: 'country_id', label: 'Country Code'},
          {key: 'from_location_id' ,label: 'Location From'},
          {key: 'to_location_id' ,label: 'Location To'},
          {key: 'wto_date' ,label: 'Date'},
          {key: 'wto_num' ,label: 'WTO No'},
          {key: 'status' ,label: 'Status'},
          {key: 'last_wtr_num' ,label: 'Last WTR',sortable: true},
          {key: 'last_wtr_date' ,label: 'WTR Date'},
          {key: 'author_user_shortname' ,label: 'Created By'}
          ],
          currentPage: 1,
          perPage: 20,
          totalRows: 0,
          noResults: false,
          exportHeaders:
          {
            'WTO No': 'wto_num',
            'WTO Date': 'wto_date',
            'Country': 'country_id',
            'Location From': 'from_location_id',
            'Location To': 'to_location_id',
            'Status':'status',
            'Last WTR':'last_wtr_num',
            'Last WTR Date':'last_wtr_date',
            'Created By':'author_user_shortname',
          },
        }
      },
      created: function()
      {
        var app_role

        app_role = JSON.parse(localStorage.getItem('app_role'))
        this.isWtrAdmin = app_role.includes('WTR_ADMIN')
      },
      methods:
      {
        print()
        {
            var rows = []
            var row = []
            var date = new Date()
            rows.push([
            'WTO No',
            'WTO Date',
            'Country Code',
            'Location From',
            'Location To',
            'Status',
            'Last WTR',
            'Last WTR Date',
            'Created By'
            ])

            for (let key in this.searchResults)
            {
              var data = this.searchResults[key]
              row =
              [
                data.wto_num,
                data.wto_date,
                data.country_id,
                data.from_location_id,
                data.to_location_id,
                data.status,
                data.last_wtr_num,
                data.last_wtr_date,
                data.author_user_shortname
              ]
              rows.push(row)
            }
            var dd = {
              header:{ text: 'Warehouse Transfer Receiving List generated on'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:8 },
              pageSize: 'A4',
              pageOrientation: 'landscape',

              // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
              pageMargins: [30, 30, 30, 20 ],
              defaultStyle: {
            font: 'ukai'
          },
              content: [
                {
                  fontSize:10,
                  layout: 'lightHorizontalLines', // optional
                  table:
                  {
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto','auto'],
                    body:
                      rows
                  }
                }
              ]
            };

            pdfMake.createPdf(dd).open();
      },
        getRowCount (items)
        {
          return items.length
        },
        search()
        {
          this.loading = true
          var sf =
          [
            "wto_num LIKE " + this.filter.wto_num
            ,"wtrs_list LIKE " + this.filter.wtr_num
            ,"country_id = " + this.filter.country_id
            ,"wto_date >= " + this.filter.date_start
            ,"wto_date <= " + this.filter.date_end
            ,"status = " + this.filter.status
          ]
         axios.post(apiWtrSearch, sf,authHeader())
            .then (res =>
            {
                return res
            })
            .then (data =>
            {
                const resultArray = []
                const myData = data.data.data.list
                for (let key in myData)
                {
                    var date = myData[key].wto_date
                    date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    var wtrDateResult = '-'
                    if(myData[key].last_wtr_date != null)
                    {
                      var wtrDate = myData[key].last_wtr_date
                      wtrDate = new Date(wtrDate)
                      wtrDateResult = "" + (wtrDate.getDate() > 9 ? '' : '0') + wtrDate.getDate() + '/'+  ((wtrDate.getMonth() + 1) > 9 ? '' : '0') + (wtrDate.getMonth() + 1) + '/' + wtrDate.getFullYear()
                    }
                    var wtr_num = '-'
                    if(myData[key].last_wtr_num != null)
                    {
                      wtr_num = myData[key].last_wtr_num
                    }
                    myData[key].last_wtr_num = wtr_num
                    myData[key].wto_date=result
                    myData[key].last_wtr_date = wtrDateResult
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray

                if(this.searchResults.length ==0)
                {
                    this.loading = false
                    this.noResults =true
                }
            })
            .catch(error => alert(error))
        },
        newWTR()
        {
          localStorage.setItem("wtr_new.wto_num", "")
          this.$router.push({ name: 'Warehouse Transfer Receiving Entry (WTR)', params: { wtrNum: '_new' }})
        },
        setCountry(obj)
        {
              var id
              if (obj !== null)
              {
                id = obj.id
              }
              else
              {
                id = null
              }
              this.filter.country_id = id
        },
        rowClick(item, index)
        {
          localStorage.setItem("wtr_new.wto_num", item.wto_num)
          this.$router.push({ name: 'Warehouse Transfer Receiving Entry (WTR)', params: { wtrNum: '_new' }})
        }
      }
    }
  </script>



// WEBPACK FOOTER //
// src/views/wtr/wtrs.vue